import React, {
  MouseEvent, useCallback, useEffect, useRef, useState,
} from 'react';
import { Button, ButtonModes } from './Button';
import { Modal } from './Modal';

interface VideoModalProps {
  handleClose: () => void,
  movie: string,
  [x: string]: any,
}

type MovieSpec = Array<string>;
interface PosterMovies {
  main: MovieSpec,
  others: Array<MovieSpec>,
}

interface VideoProps {
  movie: string,
  posterMovies?: PosterMovies
  [x: string]: any,
}

const VideoModal: React.FC<VideoModalProps> = (
  {
    handleClose, movie, children, ...rest
  },
) => {
  const vidRef = useRef<any>();

  useEffect(() => {
    vidRef.current?.play();
  }, []);

  return (
    <Modal
      onClose={handleClose}
      withVideo
    >
      <div className="video-player video-player--playing">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          className="video-player__video video-player__video--playing"
          ref={vidRef}
          controls
          {...rest}
        >
          {children}
          <source src={movie} type="video/mp4" />
        </video>
      </div>
    </Modal>
  );
};

export const VideoWithButton: React.FC<VideoProps> = (
  {
    movie,
    posterMovies,
    children,
    ...rest
  },
) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const backgroundVidRef = useRef<any>();

  useEffect(() => {
    backgroundVidRef.current?.play();
  }, []);

  const handleClose = useCallback(() => {
    setVideoPlaying(false);
    backgroundVidRef.current?.play();
  }, []);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    backgroundVidRef.current?.pause();
    setVideoPlaying(true);
  };

  return (
    <>
      {videoPlaying && (
      <VideoModal
        handleClose={handleClose}
        movie={movie}
        {...rest}
      >
        {children}
      </VideoModal>
      )}
      <div className="video-player">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          className="video-player__video"
          autoPlay
          muted
          loop
          {...rest}
          onClick={handleClick}
          ref={backgroundVidRef}
        >
          {posterMovies ? (
            <>
              {
                posterMovies.others.map(([src, type]) => (
                  <source
                    key={src}
                    type={type}
                    src={src}
                  />
                ))
              }
              <source src={posterMovies.main[0]} type={posterMovies.main[1]} />
            </>
          ) : (
            <>
              {children}
              <source src={movie} type="video/mp4" />
            </>
          )}
        </video>
        <Button
          mode={ButtonModes.gray}
          isButton
          onClick={handleClick}
        >
          ▶︎  Obejrzyj
        </Button>
      </div>
    </>
  );
};
